import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import Timer, { TimerHelper } from 'yoda-core-components/lib/components/Timer/Timer';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import TimerComponent from 'yoda-core-components/lib/assets/svg/Timer.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './TimerWrapper.css';

const cx = classNames.bind(styles);

class TimerWrapper extends Component {
    static propTypes = {
        wrapperBackgroundTheme: PropTypes.string,
        timerTextColor: PropTypes.string,
        liveTextLabel: PropTypes.string,
        liveTextLabelColor: PropTypes.string,
        wrapperClassName: PropTypes.string,
        timerParentWrapper: PropTypes.string,
        livetextTheme: PropTypes.string,
        displayTimer: PropTypes.string,
        finishTime: PropTypes.instanceOf(Date),
        timerZone: PropTypes.string,
        timerWrapperThemeConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        timerSuffix: PropTypes.bool,
        removeTimerZeros: PropTypes.bool,
        liveTextLabelClassName: PropTypes.string,
        timerTextConfig: PropTypes.shape({
            h: PropTypes.string,
            m: PropTypes.string,
            s: PropTypes.string,
        }),
        text: PropTypes.oneOf(['on', 'off']),
        removeLiveTextOnDays: PropTypes.string,
        colorConfig: PropTypes.shape({
            textColor: PropTypes.string,
            suffixColor: PropTypes.string,
            digitBoxbgColor: PropTypes.string,
        }),
        digitSplit: PropTypes.bool,
        animate: PropTypes.bool,
        daysLeftMesg: PropTypes.string,
        displaySingleDimentionTimer: PropTypes.bool,
        offerExpiredLable: PropTypes.string,
        removePrecedingZeros: PropTypes.bool,
        addAdditionalMinute: PropTypes.bool,
        displayIcon: PropTypes.bool,
        couponCode: PropTypes.string,
    };

    static defaultProps = {
        wrapperBackgroundTheme: '',
        timerTextColor: '',
        liveTextLabel: '',
        livetextLabelClass: '',
        liveTextLabelColor: '',
        finishTime: '',
        wrapperClassName: '',
        timerParentWrapper: '',
        livetextTheme: '',
        displayTimer: '',
        timerZone: 'CST',
        timerWrapperThemeConfig: [],
        timerSuffix: false,
        removeTimerZeros: false,
        timerTextConfig: {
            h: 'hours',
            m: 'mins',
            s: 'secs',
        },
        text: 'on',
        removeLiveTextOnDays: '',
        liveTextLabelClassName: '',
        digitSplit: false,
        colorConfig: {
            textColor: '',
            suffixColor: '',
            digitBoxbgColor: '',
        },
        animate: false,
        daysLeftMesg: 'DAYS LEFT!',
        displaySingleDimentionTimer: false,
        offerExpiredLable: 'Offer has expired',
        removePrecedingZeros: false,
        addAdditionalMinute: false,
        displayIcon: false,
        couponCode: '',
    };

    static getThemeConfig(timerWrapperThemeConfig, displaySingleDimentionTimer) {
        return {
            timerContainerClass: cx('timerContainer'),
            timerWrapperClass: cx('timer'),
            timerListItemClass: displaySingleDimentionTimer
                ? dt(['text-xs', 'font-bold'])
                : dt(['mr-1', 'smOnly:text-xs', 'mdOnly:text-sm', 'float-left']),
            timerNumberClass: dt(['text-brand-red']),
            timerTextClass: cx('timerText'),
            timerSuffixClass: cx('mr-1', 'smOnly:text-xs', 'mdOnly:text-sm', 'float-left'),
            ...timerWrapperThemeConfig,
        };
    }

    constructor(props) {
        super(props);
        this.expiredOffer = this.expiredOffer.bind(this);
        this.checkForTimerUpdate = this.checkForTimerUpdate.bind(this);
        this.state = {
            isOfferExpired: false,
        };
        this.timerWrapperThemeConfig = TimerWrapper.getThemeConfig(
            props.timerWrapperThemeConfig,
            props.displaySingleDimentionTimer
        );
        this.checkForTimerUpdate();
    }

    expiredOffer() {
        this.setState({
            isOfferExpired: true,
        });
    }

    checkForTimerUpdate() {
        const timeRemaining = TimerHelper.getTimeRemaining(
            `${this.props.finishTime} ${this.props.timerZone}`
        );
        if (timeRemaining.hours === 0 && timeRemaining.minutes <= 10) {
            setTimeout(
                () => {
                    this.forceUpdate();
                },
                timeRemaining.min * 60 * 1000,
                this
            );
        }
    }

    formatDate(date) {
        const d = new Date(date);
        let month = `${d.getMonth() + 1}`;
        let day = `${d.getDate()}`;
        const year = d.getFullYear();

        if (month.length < 2) month = `0${month}`;
        if (day.length < 2) day = `0${day}`;
        return [day, month, year].join('/');
    }

    renderTimer() {
        const {
            animate,
            colorConfig,
            digitSplit,
            removeTimerZeros,
            timerSuffix,
            text,
            timerTextConfig,
            finishTime,
            timerZone,
            displayTimer,
            liveTextLabelColor,
            displaySingleDimentionTimer,
            removePrecedingZeros,
            addAdditionalMinute,
            displayIcon,
            couponCode,
        } = this.props;
        const offerEndDate =
            finishTime && finishTime.toString().indexOf('T') > 0
                ? `${finishTime}`
                : `${finishTime} ${timerZone}`;
        const timeRemaining = TimerHelper.getTimeRemaining(offerEndDate);
        const displayTime = timeRemaining.days === 0 && timeRemaining.total > 0;
        const displayTimeTimerHtmlClass = displayTime
            ? dt(['inline-block', 'pr-3'])
            : `${dt(['inline-block', 'pr-3'])} ${cx('timerwithDays')}`;
        const offerEndsTextClass = displayTime
            ? dt([
                  'inline-block',
                  'tracking-[-0.4px]',
                  'font-normal',
                  'text-xs',
                  'leading-5',
                  'pr-3',
                  'text-gray-60',
              ])
            : cx(
                  'inline-block',
                  'tracking-[-0.4px]',
                  'font-normal',
                  'text-xs',
                  'leading-5',
                  'pr-3',
                  'text-gray-60',
                  'smOnly:align-baseline'
              );
        /* istanbul ignore next */
        const displayTimerWithTime = displayTime ? cx('displayTimerWithTime') : '';
        let displayTimerHtml = '';
        const timerHtml = displayTime ? (
            <Timer
                endTime={offerEndDate}
                themeConfig={this.timerWrapperThemeConfig}
                timerTextConfig={timerTextConfig}
                text={text}
                suffix={timerSuffix}
                completeCallback={this.expiredOffer}
                removeZeros={removeTimerZeros}
                digitSplit={digitSplit}
                timerTextColor={this.props.liveTextLabelColor}
                colorConfig={colorConfig}
                removePrecedingZeros={removePrecedingZeros}
                addAdditionalMinute={addAdditionalMinute}
                displaySingleDimentionTimer={displaySingleDimentionTimer}
                animate={animate}
            />
        ) : (
            `${timeRemaining.days + 1} ${this.props.daysLeftMesg}`
        );
        if (displayIcon) {
            displayTimerHtml = (
                <div className={cx('displayTimerHtml-wrapper')}>
                    <Icon
                        iconType="svg"
                        automationId="timer-icon"
                        width="36px"
                        height="36px"
                        viewBox="0 0 36 36"
                        className={cx('timerIcon')}
                    >
                        <TimerComponent />
                    </Icon>
                    <div
                        className={cx(
                            'display-timer',
                            'display-timer-icon',
                            displayTimer,
                            displayTimerWithTime
                        )}
                        style={{ color: liveTextLabelColor }}
                    >
                        <span className={dt(['inline-block', 'pr-1'])}>{`DAY ${
                            timeRemaining.days + 1
                        } OF COUPON CODE`}</span>
                        <span className={dt(['inline-block', 'text-brand-red', 'pr-1'])}>
                            {couponCode}
                        </span>
                        <span className={dt(['inline-block', 'mr-2', 'smOnly:pl-0'])}>ENDS IN</span>
                        <span className={displayTimeTimerHtmlClass}>{timerHtml}</span>
                        <span className={offerEndsTextClass}>{`*Offer ends ${this.formatDate(
                            offerEndDate
                        )}`}</span>
                    </div>
                </div>
            );
        } else {
            displayTimerHtml = (
                <div
                    className={cx('display-timer', displayTimer, displayTimerWithTime)}
                    style={{ color: liveTextLabelColor }}
                >
                    {timerHtml}
                </div>
            );
        }

        return displayTimerHtml;
    }

    render() {
        // prop extraction
        const {
            wrapperBackgroundTheme,
            timerTextColor,
            liveTextLabel,
            wrapperClassName,
            timerParentWrapper,
            livetextTheme,
            removeLiveTextOnDays,
            liveTextLabelClassName,
            finishTime,
            displayIcon,
        } = this.props;
        const offerEndDate =
            finishTime && finishTime.toString().indexOf('T') > 0
                ? `${finishTime}`
                : `${finishTime} ${this.props.timerZone}`;

        // Time remaining calculation with helper
        const timeRemaining = TimerHelper.getTimeRemaining(offerEndDate);
        const timer = timeRemaining.days === 0 && timeRemaining.total > 0;
        const liveTextTimer = timer ? cx('liveTextTimer') : '';
        const timeParentWrapper = timer ? cx('timeParentWrapper') : '';

        const offerExpiredClass =
            this.state.isOfferExpired || timeRemaining.total ? cx('timer-expiredclass') : '';
        const timerWithIconClass = displayIcon ? 'timer-icon-wrapper' : '';

        // Theming with classes
        const themeObject = {
            WrapperClass: cx(
                'timer-wrapper',
                timerWithIconClass,
                wrapperClassName,
                offerExpiredClass
            ),
            Timerparent: cx('timerparent-wrapper', timerParentWrapper, timeParentWrapper),
            LivetextClassName: `${cx(livetextTheme, liveTextTimer)} ${dt(['inline-block'])}`,
            liveTextLabelClassName: `${dt(['align-top'])} ${cx(liveTextLabelClassName)}`,
        };

        // livetext html
        let liveTextHtml =
            liveTextLabel.trim() !== '' && liveTextLabel ? (
                <span
                    className={themeObject.liveTextLabelClassName}
                    style={{ color: timerTextColor }}
                >
                    {liveTextLabel}
                </span>
            ) : null;

        if (removeLiveTextOnDays && timeRemaining.days > 0) {
            liveTextHtml = <span className={cx(removeLiveTextOnDays)}>{liveTextLabel}</span>;
        }

        const renderExpiredData = () => {
            let expiredData = this.props.offerExpiredLable;
            if (!this.state.isOfferExpired && timeRemaining.total > 0) {
                expiredData = (
                    <div className={themeObject.Timerparent}>
                        <div
                            className={themeObject.LivetextClassName}
                            style={{ color: timerTextColor }}
                        >
                            {liveTextHtml} {finishTime ? this.renderTimer() : ''}
                        </div>
                    </div>
                );
            }
            return expiredData;
        };

        return (
            <div
                className={themeObject.WrapperClass}
                style={{ backgroundColor: wrapperBackgroundTheme, color: timerTextColor }}
            >
                {' '}
                {renderExpiredData()}
            </div>
        );
    }
}

export default TimerWrapper;
